import {ICellRenderer} from 'ag-grid-community';
import {Tooltip} from 'platform/components';
import {Text} from 'platform/foundation';

import {forwardRef} from 'react';

import {useTooltipProps} from '../../hooks/useTooltipProps';
import {ICellRendererParams} from '../../types/AgGridTypes';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getStylesToRender} from '../../utils/getStylesToRender';
import {getValueToRender} from '../../utils/getValueToRender';

export interface TimeIntervalCellRendererProps extends ICellRendererParams {
  getTooltipProps?: TooltipGetter;
}

function TimeIntervalCellRendererComponent(
  props: TimeIntervalCellRendererProps,
  _ref: React.Ref<ICellRenderer>
) {
  const {getTooltipProps, data, node, colDef} = props;
  const className = getCellClassName(colDef);
  const cellValue = getValueToRender(props);
  const cellStyles = getStylesToRender(props);

  const tooltipProps = useTooltipProps(data, node, getTooltipProps);

  return (
    <Tooltip {...tooltipProps}>
      {/* eslint-disable-next-line react/forbid-dom-props */}
      <div className={className}>
        <Text color={cellStyles?.textColor} noWrap={!colDef?.wrapText} size="small">
          {cellValue}
        </Text>
      </div>
    </Tooltip>
  );
}

export const TimeIntervalCellRenderer = forwardRef<ICellRenderer, TimeIntervalCellRendererProps>(
  TimeIntervalCellRendererComponent
);
